import { z } from "zod";
import { changeMsisdnOrchestrator } from "./changeMsisdnOrchestrator";
import { changeSimEsimOrchestrator } from "./changeSimEsimOrchestrator";
import { fsecureOrchestrator } from "./fsecureOrchestrator";
import { fsecureReactivationOrchestrator } from "./fsecureReactivationOrchestrator";
import { ftthOrchestrator } from "./ftthOrchestrator";
import { ftthReactivationOrchestrator } from "./ftthReactivationOrchestrator";
import { groupOrchestrator } from "./groupOrchestrator";
import { mobileOrchestrator } from "./mobileOrchestrator";
import { mobileReactivationOrchestrator } from "./mobileReactivationOrchestrator";
import { modemReturnOrchestrator } from "./modemReturnOrchestrator";
import { multiOrderOrchestrator } from "./multiOrderOrchestrator";
import { tvOrchestrator } from "./tvOrchestrator";

export const orchestrator = z.union([
  ftthOrchestrator,
  fsecureOrchestrator,
  modemReturnOrchestrator,
  ftthReactivationOrchestrator,
  mobileReactivationOrchestrator,
  mobileOrchestrator,
  changeMsisdnOrchestrator,
  groupOrchestrator,
  tvOrchestrator,
  multiOrderOrchestrator,
  changeSimEsimOrchestrator,
  fsecureReactivationOrchestrator,
]);

export const orchestrators = z.array(orchestrator);

export const verificationErrorResponse = z.object({
  code: z.literal("50193"),
});
